"use client";
import { FC, useEffect } from "react";

import AuthLoading from "./AuthLoading";
import { useAuth } from "./CognitoAuthContext";

export default function withAuth(Component: FC) {
  function Auth(props: object) {
    const { isAuthenticated, isLoading, login } = useAuth();

    // If user is not logged in, redirect to identity provider
    useEffect(() => {
      if (!isAuthenticated && !isLoading) {
        login();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps -- only run when isAuthenticated, isLoading changes
    }, [isAuthenticated, isLoading]);

    if (isLoading || !isAuthenticated) {
      return <AuthLoading />;
    }

    // If user is logged in, return original component
    return <Component {...props} />;
  }

  return Auth;
}
